import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Flex, Menu, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../../../../../components/DropdownMenu';
import { findSelected } from '../../../../../../components/DropdownMenu/util';
import { moveDepartmentData } from '../../../../../../redux/modules/adminPage';
import { selectCompanyDepartments } from '../../../../../../redux/modules/company';

const MoveDepartmentsSelectBox = ({ department, label }) => {
  const dispatch = useDispatch();
  const departments = useSelector(selectCompanyDepartments);
  const otherDepartments = departments.filter(current => current.departmentId !== department.departmentId).sort(((a, b) => b.archivedAt - a.archivedAt));

  const [selectedDepartment, setDepartment] = useState(null);
  const [showArchiveMessage, setShowArchiveMessage] = useState(false);

  const handleOptionClick = selected => {
    const departmentSelected = findSelected(otherDepartments, Number(selected.value), 'departmentId');
    if (departmentSelected.archivedAt) {
      setShowArchiveMessage(true);
    }

    setDepartment(departmentSelected);
    dispatch(moveDepartmentData({
      fromDepartmentId: department.departmentId,
      toDepartmentId: departmentSelected.departmentId
    }));
  };

  if (otherDepartments && !otherDepartments.length) {
    return (
      <Box my={2}>
        <Text color="error.primary.600" textStyle="bodyXl500">No Departments</Text>
        <Text color="greyScale.800">Please create a new department in order to transfer data</Text>
      </Box>
    );
  }

  if (otherDepartments && otherDepartments.length) {
    return (
      <Box bg="white" borderRadius="10px" mt={2} w="100%">
        <Flex alignItems="center" direction="row" justifyContent="space-around" w="100%">
          <Flex
            alignItems="center"
            direction="column"
            height="100%"
            justifyContent="space-evenly"
            m="2"
          >
            <Text alignSelf="flex-start" color="greyScale.700" mb={2}>{label}</Text>
            <Menu _focus={{ outline: 'none' }} isOpen={false}>
              <DropdownMenu
                idKey="departmentId"
                labelKey="departmentName"
                options={otherDepartments}
                selected={selectedDepartment
                  ? selectedDepartment.departmentName
                  : ''}
                variant="secondary"
                width="380px"
                onSelect={handleOptionClick}
              />
            </Menu>
          </Flex>
        </Flex>
        <Box mt={2}>
          {showArchiveMessage
            && (
            <Text color="greyScale.800" textStyle="bodySm500">
              {`Note: ${selectedDepartment.departmentName} is an archived department. Any active jobs will be archived and can be reactivated at any time`}
            </Text>
            )}
        </Box>
      </Box>
    );
  }

  return null;
};

MoveDepartmentsSelectBox.propTypes = {
  department: PropTypes.shape({ departmentId: PropTypes.number }),
  label: PropTypes.string
};

export default MoveDepartmentsSelectBox;
